export default __webpack_public_path__ + "static/108016-f754239654440fbcc6f01dc597dc85fa.jpg";